import React, { useContext } from "react";
import SelectBox from "components/FormElements/SelectBox";
import Label from "components/FormElements/Label";
import { ContainerContext } from "context/Container";

export default function ContainerTypeField(props) {
    const { state } = useContext(ContainerContext);

    if (state.loading) {
        return (
            <div>
                <Label>Type</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <SelectBox
            label="Type"
            name="type"
            id="type"
            disabled={
                state.loading ||
                state.preformingStateChange ||
                !state.isUserEditable
            }
            options={["automatic", "manual"]}
        />
    );
}
